export enum NWONPage {
  Home = "Home",
  Projects = "Projects",
  Team = "Team",
  Services = "Services",
  Imprint = "Imprint",
  PrivacyPolicy = "PrivacyPolicy",
  NotFound = "NotFound",
}
